import type {CoreEntityType} from 'nutshell-core/types';

import {AccountIcon} from 'shells/icon/svg/account-icon';
import {ContactIcon} from 'shells/icon/svg/contact-icon';
import {LeadIcon} from 'shells/icon/svg/lead-icon';

const entityConstants = {
    leads: {
        icon: LeadIcon,
        graduatedFilters: ['owner', 'status', 'priority', 'stageset', 'creatorOriginCategory'],
        baseUrl: '/leads',
        primaryFilters: [
            'closedTime',
            'createdTime',
            'lastContactedTime',
            'outcome',
            'owner',
            'sources',
            'stage',
            'stageset',
            'status',
            'tags',
            'value',
            'origin',
        ],
    },
    accounts: {
        icon: AccountIcon,
        graduatedFilters: ['owner', 'accountType'],
        baseUrl: '/companies',
        primaryFilters: [
            'email',
            'phone',
            'address',
            'accountType',
            'tags',
            'lastContactedTime',
            'owner',
            'createdTime',
            'contacts',
            'origin',
        ],
    },
    contacts: {
        icon: ContactIcon,
        graduatedFilters: ['owner'],
        baseUrl: '/people',
        primaryFilters: [
            'email',
            'phone',
            'address',
            'tags',
            'lastContactedTime',
            'owner',
            'createdTime',
            'accounts',
            'origin',
        ],
    },
} as const;

export const getEntityIcon = (entityType: CoreEntityType) => {
    return entityConstants[entityType].icon;
};

export const getEntityBaseUrl = (entityType: CoreEntityType) => {
    return entityConstants[entityType].baseUrl;
};

export const getEntityGraduatedFilters = (entityType: CoreEntityType) => {
    // @ts-expect-error
    let filters: string[] = entityConstants[entityType].graduatedFilters;

    const isEngagementLeadsPage = window.location.pathname.includes('/inbox/leads');

    if (NutClientConfig.hasEngagementBarV2FF && isEngagementLeadsPage && entityType === 'leads') {
        return ['owner', 'status', 'creatorOriginCategory'];
    }

    if (
        !(NutClientConfig.hasEngagementBarV2FF && isEngagementLeadsPage) &&
        entityType === 'leads'
    ) {
        filters = filters.filter((filterName) => filterName !== 'creatorOriginCategory');
    }

    if (!NutClientConfig.hasHotLeads && entityType === 'leads') {
        filters = filters.filter((filterName) => filterName !== 'priority');
    }

    return filters;
};

export const getPrimaryFilters = (entityType: CoreEntityType) => {
    return entityConstants[entityType].primaryFilters;
};
